export const axiosBaseQuery = (axiosInstance) => {
  return async ({ url, method, data, params, headers, ...rest }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
        ...rest,
      });
      return { data: result.data };
    } catch (axiosError) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };
};
